exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../../styles/typography.css"), undefined);

// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"noDataMsg": "NoData--noDataMsg--1dln7 " + require("-!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../../styles/typography.css").locals["mediumContrastText"] + " " + require("-!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../../styles/typography.css").locals["svgMiddleAnchored"] + ""
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!./~/postcss-loader!./src/components/trends/common/NoData.css
 ** module id = 158
 ** module chunks = 0
 **/